import { render, staticRenderFns } from "./AIAssistantPanel.vue?vue&type=template&id=fec69394&scoped=true"
import script from "./AIAssistantPanel.vue?vue&type=script&lang=js"
export * from "./AIAssistantPanel.vue?vue&type=script&lang=js"
import style0 from "./AIAssistantPanel.vue?vue&type=style&index=0&id=fec69394&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec69394",
  null
  
)

export default component.exports